import { client } from './client';

export const verifyMoveIn = ({ udprn, moveInDate }) =>
  client('move-in-verify', {
    method: 'POST',
    body: {
      udprn,
      moveInDate
    }
  });
